













import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { parseUrlSearch, logger } from '@tt4b/ttam-utils';
import { computed, defineComponent, PropType, toRefs, watch, ref } from '@vue/composition-api';
import { useAdgroupBaseValidate } from '@tt4b/ttam-hooks';
import ExistingAdGroup from './index';

const name = 'ttam-existing-adgroup-compose';
export default defineComponent({
  name,
  components: {
    TtamExistingAdGroup: ExistingAdGroup.TtamExistingAdGroup,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignData } = toRefs(props);
    const { adIdValidator } = useAdgroupBaseValidate();
    const { campaignId } = ExistingAdGroup.usePropsCampaignId({ campaignData });
    const { disabled } = ExistingAdGroup.usePropsSelectDisabled({ campaignId });
    const { loading, data: adGroupList, run } = ExistingAdGroup.useDataSource({ campaignId });
    const isInit = ref(false); // 标志 campaignId 变化，进入页面第一次 adId 变化
    const _adId = computed({
      get: () => props.adgroupData.adId,
      set: val => {
        if(val !== props.adgroupData.adId) {
          const curItem = adGroupList.value.find(item => String(item.adId) === val);
          const curName = curItem?.adName || '';
          emit('input', val);
          emit('change', val, curName, isInit.value);
          isInit.value = false; // 第一次 setFormData 后设为 false，以后一直为 false
        }
      },
    });

    watch(
      campaignId,
      async (newVal, oldVal) => {
        if (newVal !== oldVal && newVal) {
          await run();
          const adgroupId = parseUrlSearch()?.adgroup_id;
          if (adGroupList.value?.find?.(item => `${item.adId}` === adgroupId)) {
            isInit.value = true;
            _adId.value = adgroupId;
          } else if (adgroupId) {
            logger.warn('adgroupId=%s not in list', adgroupId);
          }
        }
      },
      {
        immediate: true,
      },
    );

    return {
      name,
      adIdValidator,
      campaignId,
      disabled,
      _adId,
      loading,
      adGroupList,
    };
  },
});
